import React, { useEffect, useState } from "react";

const AddressPage = () => {

  const [addresses, setAddresses] = useState([]);
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    pincode: "",
    state: "",
    city: "",
    addressLine: "",
    landmark: ""
  });

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    const res = await fetch(
      "https://lappyshop.onrender.com/api/get-address",
      { credentials: "include" }
    );
    const data = await res.json();
    if (data.success) setAddresses(data.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch(
      "https://lappyshop.onrender.com/api/add-address",
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      }
    );

    fetchAddresses();
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">
        Manage Addresses
      </h2>

      <form onSubmit={handleSubmit} className="grid gap-3 mb-6">
        <input placeholder="Full Name" onChange={(e)=>setForm({...form, fullName:e.target.value})}/>
        <input placeholder="Phone" onChange={(e)=>setForm({...form, phone:e.target.value})}/>
        <input placeholder="Pincode" onChange={(e)=>setForm({...form, pincode:e.target.value})}/>
        <input placeholder="State" onChange={(e)=>setForm({...form, state:e.target.value})}/>
        <input placeholder="City" onChange={(e)=>setForm({...form, city:e.target.value})}/>
        <input placeholder="Address Line" onChange={(e)=>setForm({...form, addressLine:e.target.value})}/>
        <input placeholder="Landmark" onChange={(e)=>setForm({...form, landmark:e.target.value})}/>
        <button className="bg-red-600 text-white p-2 rounded">
          Add Address
        </button>
      </form>

      <div className="space-y-3">
        {addresses.map((addr) => (
          <div key={addr._id} className="border p-3 rounded">
            <p className="font-medium">{addr.fullName}</p>
            <p>{addr.addressLine}, {addr.city}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddressPage;